module.exports = __webpack_public_path__ + "media/images/lp_mv-bg-f32b838b99f7752aeefec44237c3866e.webp";